import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { EmptyStateIllustration } from './EmptyState.illustration';

export interface EmptyStateProps {
  title: string;
  description: string;
  cta?: ReactNode;
  illustration?: ReactNode;
}

/**
 * Empty-state card with the torn-document illustration.
 *
 * Renders Atlas Lens styling — mount inside `<AtlasMuiThemeProvider>`.
 *
 * Used by the categories audit log drawer (no CTA) and (future) the categories
 * table empty state (with CTA slot for the Add new category split button).
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  cta,
  illustration,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      px: 3,
      py: 6,
      gap: 2,
    }}
    data-testid="empty-state"
  >
    {illustration ?? <EmptyStateIllustration />}
    <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
      {title}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {description}
    </Typography>
    {cta ? <Box sx={{ mt: 2 }}>{cta}</Box> : null}
  </Box>
);
